module.exports = __webpack_public_path__ + "img/zm.05a781c1.jpg";